export default "__VITE_ASSET__ypZW_tsU__"